import Utils from "./utils";
import { ApiControllerSettings } from "@infoland/iprova-api";
import storeHelper from "./store/store-helper";
export default class {
    public static get iProvaUrl(): string {
        // ensure the url does not have trailing '/'
        return (window as any).iProvaUrl;
    }

    /** Sets the iprova url */
    public static set iProvaUrl(iprovaUrl: string) {
        // ensure the url does not have trailing '/'
        (window as any).iProvaUrl = iprovaUrl.replace(/\/$/, "");
    }

    /** Gets the url to the iProva API root */
    public static get iProvaApiUrl(): string {
        return this.iProvaUrl + "/api";
    }
    public static GetAuthenticatedUrl(url: string): String {
        let seperator = url.indexOf("?") == -1 ? "?" : "&";
        return `${url}${seperator}${ApiControllerSettings.xsrfHeaderName}=${encodeURIComponent(
            Utils.getCookie(ApiControllerSettings.xsrfCookieName)
        )}`;
    }

    public static startOfficeOnline(accessToken: string, accessTokenTTL: number, actionUrl: string, frameholder: HTMLElement) {
        if (!frameholder) {
            throw "No element to put the office online frame in.";
        }

        let office_frame: HTMLIFrameElement = document.getElementById("office_online_frame") as HTMLIFrameElement;
        if (!office_frame) {
            office_frame = document.createElement("iframe");
        }

        //generate the office frame
        //Set name and id to office_frame so it can be used in css
        office_frame.name = "office_online_frame";
        office_frame.id = "office_online_frame";
        // The title should be set for accessibility
        office_frame.title = "Office Online Frame";
        //set style
        office_frame.style.width = "100%";
        office_frame.style.height = "100%";
        office_frame.style.top = "58px";
        office_frame.style.left = "0";
        office_frame.style.right = "0";
        office_frame.style.bottom = "0";
        office_frame.style.border = "none";
        office_frame.style.display = "block";
        // This attribute allows true fullscreen mode in slideshow view
        // when using PowerPoint Online's 'view' action.
        office_frame.setAttribute("allowfullscreen", "true");

        //create form data to send for the office application
        let form: HTMLFormElement = document.createElement("form");
        let accessTokenFormInput: HTMLInputElement = document.createElement("input");
        let accessTokenTtlFormInput: HTMLInputElement = document.createElement("input");
        document.body.appendChild(form);
        form.appendChild(accessTokenFormInput);
        form.appendChild(accessTokenTtlFormInput);
        form.name = "office_online_form";
        form.target = office_frame.name;
        form.method = "POST";
        form.action = actionUrl;
        accessTokenFormInput.id = "access_token_form";
        accessTokenFormInput.name = "access_token";
        accessTokenFormInput.type = "hidden";
        accessTokenFormInput.value = accessToken;
        accessTokenTtlFormInput.id = "access_token_ttl_form";
        accessTokenTtlFormInput.name = "access_token_ttl";
        accessTokenTtlFormInput.type = "hidden";
        accessTokenTtlFormInput.value = accessTokenTTL.toString();

        frameholder.appendChild(office_frame);
        form.submit();

        document.body.removeChild(form);
    }
}
